import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { baseUrl } from "app/constants";
import axios from "axios";

export const getPriceList = createAsyncThunk(
  "productAlt/getPriceList",
  async ({ uid }) => {
    try {
      const response = await axios.post(`${baseUrl}get_price_service`, {
        appid: uid,
      });
      // console.log(response.data.response);
      return response.data.response;
    } catch (error) {
      console.log(error);
    }
  }
);

const initialState = {
  priceList: [],
  status: "idle",
  error: null,
};

const productAltSlice = createSlice({
  name: "productAlt",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(getPriceList.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getPriceList.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.priceList = action.payload;
      })
      .addCase(getPriceList.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default productAltSlice.reducer;
